/**
 * Check if `a` is one of `[...b]`
 */
export function isOneOf(a, b) {
  if (b === void 0) {
    b = [];
  }
  return b.some(function (v) {
    return a === v;
  });
}